import { Helmet } from 'react-helmet-async'
import { ContactDetails } from '../components/ContactDetails'
import { ContactForm } from '../components/ContactForm'
import { Maps } from '../components/Maps'

export const Contact = () => {
  return (
    <>
      <Helmet title="Contact Us" />
      <ContactDetails />
      <Maps />
      <ContactForm />
    </>
  )
}
